import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SharedModule } from "src/app/shared/shared.module";
import { AccesosComponent } from "./accesos/accesos.component";
import { NgbAccordionModule } from "@ng-bootstrap/ng-bootstrap";
import { AccesosRoutingModule } from "./accesos.routing.module";

@NgModule({
    declarations: [
        AccesosComponent
    ],
    imports: [
        CommonModule , 
        FormsModule , 
        ReactiveFormsModule , 
        SharedModule, 
        AccesosRoutingModule , 
        NgbAccordionModule
    ]
})
export class AccesosModule {}